<h4 *ngIf="isLinkCreate">Create An Affiliate Link</h4>

<h4 *ngIf="!isLinkCreate && !isLinkEdit">Affiliate link Detail</h4>
<h4 *ngIf="!isLinkCreate && isLinkEdit">Customize your Affiliate link</h4>

<div [formGroup]="userForm">
    <div class="row">
        <div
            class="col-md-10"
            style="margin-bottom: 20px;"
        ><em>*</em> Indicates required fields.</div>
        <div class="col-md-2">
            <label *ngIf="!isLinkCreate">
                <input
                    type="checkbox"
                    (click)="toggleEdit()"
                    class="ng-pristine ng-valid"
                    [checked]="isLinkEdit"
                > Enable Edit
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-5">
            <div class="form-group">
                <label>Product Type <em>*</em></label>
                <select
                    [attr.disabled]="isLinkEdit == false ? true : null || isLinkCreate == false ? true : null"
                    formControlName="productType"
                    (change)="previewLink()"
                    class="form-control"
                    name="type"
                >
                    <option
                        *ngFor="let productType of productTypes"
                        [ngValue]="productType"
                    >{{productType.type}}</option>
                </select>
                <small
                    class="error"
                    *ngIf="f.productType.dirty && f.productType.errors?.required"
                >Please select a product type.</small>
            </div>
            <div
                class="form-group"
                *ngIf="brandId == 2"
            >
                <label>Delivery Method </label>
                <select
                    [attr.disabled]="this.f.productType.value.value !== 0 ? true : null || isLinkEdit == false ? true : null || isLinkCreate == false ? true : null"
                    formControlName="deliveryMethod"
                    (change)="previewLink()"
                    class="form-control"
                    name="type"
                >
                    <option
                        *ngFor="let deliveryMethod of deliveryMethods"
                        [ngValue]="deliveryMethod"
                    >{{deliveryMethod.name}}</option>
                </select>
                <small
                    class="error"
                    *ngIf="f.deliveryMethod.dirty && f.deliveryMethod.errors?.required"
                >Please select a delivery method.</small>
            </div>
            <div class="form-group">
                <label>Link Text <em>*</em></label>
                <input
                    [readonly]="!isLinkEdit"
                    (change)="previewLink()"
                    formControlName="linkName"
                    type="text"
                    class="form-control"
                    name="label"
                    placeholder="{{linkPlaceholderText}}"
                    maxlength="128"
                    autofocus
                />
                <small
                    class="error"
                    *ngIf="f.linkName.dirty && f.linkName.errors?.required"
                >Please enter in the link text.</small>
            </div>
            <div
                class="form-group"
                *ngIf="f.productType.value.isForIP == false"
            >
                <label>Link Type <em>*</em></label>
                <select
                    [attr.disabled]="isLinkEdit == false ? true : null"
                    formControlName="linkType"
                    (change)="previewLink()"
                    class="form-control"
                    name="type"
                >
                    <ng-container *ngFor="let linkType of linkTypes | slice:0:4">

                        <option
                            *ngIf="linkType !== 'Link'"
                            [ngValue]="linkType"
                        >{{linkType.type}}</option>
                    </ng-container>
                </select>
                <small
                    class="error"
                    *ngIf="f.linkType.dirty && f.linkType.errors?.required"
                >Please select a link type.</small>
            </div>
            <div class="form-group">
                <label>Description</label>
                <input
                    [readonly]="!isLinkEdit"
                    formControlName="description"
                    (change)="previewLink()"
                    name="description"
                    type="text"
                    class="form-control"
                    maxlength="100"
                />
            </div>
            <label><input
                    [attr.disabled]="isLinkEdit == false ? true : null"
                    type="checkbox"
                    formControlName="toOpenNewWin"
                    (change)="previewLink()"
                    class="ng-pristine ng-valid"
                >&nbsp; Open in new window</label>
        </div>
        <div
            class="col-md-7"
            *ngIf="f.productType.value.isForIP == false"
        >
            <h4>Link Preview</h4>
            <div
                style="text-align: center;padding:5px;border:solid;border-width:thin;min-height: 100px;border-color: lightgrey;"
                [innerHtml]="htmlContent"
            ></div>
        </div>
    </div>

    <br />
    <div
        class="row reviewOrder"
        *ngIf="isLinkShowing"
    >
        <div class="col-md-12">
            <h4>affiliate link</h4>
            <div class="form-group">
                <p>Get HTML code for this affiliate link.</p>
            </div>
            <div class="terms-and-conditions af-link">
                <div id="af-link-html-content">{{htmlContent}}</div>
            </div>
        </div>
    </div>

    <br />
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                By continuing you are confirming that the information you’ve entered is correct and agree to our Service Terms.
            </div>
            <div class="form-group">
                <button
                    *ngIf="isLinkShowing"
                    class="btn btn-secondary"
                    type="button"
                    (click)="copyHTML()"
                >
                    Copy to clipboard
                </button>
                <button
                *ngIf="isLinkShowing"
                class="btn btn-secondary"
                type="button"
                (click)="copyLink()"
            >
                Copy as URL
            </button>
                <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="close()"
                >
                    Close
                </button>
                <button
                    [disabled]="!isLinkEdit"
                    type="button"
                    class="btn btn-primary"
                    (click)="save()"
                >
                    <span *ngIf="isLinkCreate">Create</span>
                    <span *ngIf="!isLinkCreate">Update</span>
                </button>
            </div>
        </div>
    </div>
</div>
